<template>
    <ContentOrLoading>
        <InformeCard v-if="datos" title="Filtrar por fechas / Temporada">
            <div class="col-12">
                <div class="info-box" :id="'total-' + tipo">
                    <span class="info-box-icon bg-info"><i class="fas fa-ticket-alt"></i></span>

                    <div class="info-box-content">
                        <span class="info-box-text">TOTAL {{ tipo }}:</span>
                        <span class="info-box-number">{{ vendidas }}</span>
                    </div>
                    
                </div>
            </div>
            <div class="col-12">
                <div class="info-box" id="total-recaudacion">
                    <span class="info-box-icon bg-info"><i class="far fa-money-bill-alt"></i></span>

                    <div class="info-box-content">
                        <span class="info-box-text">TOTAL RECAUDACIÓN (€):</span>
                        <span class="info-box-number">{{ datos.total_recaudacion ? datos.total_recaudacion : datos.importe | formatear_precio }}</span>
                    </div>
                </div>
            </div>
        </InformeCard>
    </ContentOrLoading>
</template>

<script>
import InformeCard from "../InformeCard";

export default {
    props: ['tipo', 'fecha_inicio', 'fecha_fin', 'lista_id', 'totales'],
    data() {
        return {
            loading: false,
            datos: this.totales ? this.totales : null
        }
    },
    created() {
        if (!this.totales) {
            this.getTotales();
        }
    },
    methods: {
        getTotales() {
            this.loading = true;

            const params = {
                filters : {},
                lista_id: this.lista_id
            };

            if (this.fecha_inicio && this.fecha_fin) {
                params.filters.fecha_inicio = this.fecha_inicio;
                params.filters.fecha_fin = this.fecha_fin;
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonos.informe.totales'), params).then(res => {
                this.datos = res.data.data;
            }).finally(() => this.loading = false);
        }
    },
    computed: {
        vendidas() {
            if (this.datos.total_abonados) {
                return this.datos.total_abonados;
            } else if (this.datos.vendidas) {
                return this.datos.vendidas;
            } else {
                return 0;
            }
        }
    },
    components: {
        InformeCard,
    }
}
</script>
